import { useEffect } from 'react';
import { Link, Route, Routes } from 'react-router-dom';
import ChildSafety, { CHILD_SAFETY_TITLE } from './ChildSafety';
import TermsAndPrivacy from './policyPrivacy';
import './policy.css';

const PRIVACY_TITLE = 'Políticas de Uso e Privacidade OLM';

function PageTitle({ title, children }) {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return children;
}

function ChildSafetyPage() {
  return (
    <PageTitle title={CHILD_SAFETY_TITLE}>
      <main className="policy-container">
        <ChildSafety />
      </main>
    </PageTitle>
  );
}

function NotFoundPage() {
  return (
    <PageTitle title="Página não encontrada | Online Machine">
      <main className="policy-container">
        <h1>Página não encontrada</h1>
        <p>Não foi possível encontrar o conteúdo solicitado.</p>
        <Link to="/">Voltar para Políticas de Uso e Privacidade</Link>
      </main>
    </PageTitle>
  );
}

export default function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={(
          <PageTitle title={PRIVACY_TITLE}>
            <TermsAndPrivacy />
          </PageTitle>
        )}
      />
      <Route path="/child-safety" element={<ChildSafetyPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
